/**
 * MADERINCO-PRODUCTO-SECCION-CONTRATO-T1 (Ares #30563): "Cargar piloto Cubierta" -- reglas sin DOM, para el check.
 *
 * Contrato (nexo-api 571, servido en 1.6.809): POST /api/v1/presupuestos/plantilla/pilotos/{piloto}/casar?confirmar=true
 * Crea y casa los productos de los items del piloto que aun no tienen producto; cada item en su transaccion. Solo el
 * negocio demo (PUERTA_CERRADA fuera); sin confirmar = 400 CONFIRMACION_REQUERIDA y no escribe.
 * 200 = CasarPilotoDto {piloto, itemsDelPiloto, productosCreados, variantesReusadas, yaCasados, ubicacionesNuevas, errores[]}.
 * Repetir = 0 creados (los ya casados se cuentan aparte). Esperado por A (#30567): 35 casados, 29 productos, 29 ubicaciones.
 *
 * @module application/presupuestos/cargaPiloto
 */

export const PILOTO_CUBIERTA = 'cubierta_v01';

const num = (v) => (Number.isFinite(Number(v)) ? Number(v) : 0);

/** La respuesta en una forma (camelCase o PascalCase). */
export function resumenDelPiloto(data) {
  const d = data?.data ?? data ?? {};
  const errores = d.errores ?? d.Errores;
  return {
    piloto: String(d.piloto ?? d.Piloto ?? ''),
    items: num(d.itemsDelPiloto ?? d.ItemsDelPiloto),
    creados: num(d.productosCreados ?? d.ProductosCreados),
    variantes: num(d.variantesReusadas ?? d.VariantesReusadas),
    yaCasados: num(d.yaCasados ?? d.YaCasados),
    ubicaciones: num(d.ubicacionesNuevas ?? d.UbicacionesNuevas),
    errores: Array.isArray(errores) ? errores.map(String) : []
  };
}

/** Las lineas del resultado: lo que paso, sin redondear, y si fue repeticion. */
export function frasesDelPiloto(r) {
  const casados = r.creados + r.variantes + r.yaCasados;
  const lineas = [];
  if (r.items === 0) lineas.push('El piloto no tiene partidas en este negocio: no se creó nada.');
  else if (r.creados === 0 && r.variantes === 0 && r.errores.length === 0)
    lineas.push(`Ya estaba cargado: ${r.items} partidas, ${r.yaCasados} ya tenían producto. No se creó nada.`);
  else lineas.push(`Piloto cargado: ${casados} de ${r.items} partidas con producto.`);
  if (r.creados || r.variantes) lineas.push(`${r.creados} productos nuevos, ${r.variantes} partidas unidas a una variante que ya existía, ${r.yaCasados} ya tenían producto.`);
  if (r.ubicaciones) lineas.push(`${r.ubicaciones} ubicaciones nuevas (en qué sección va cada producto).`);
  if (r.errores.length) lineas.push(`${r.errores.length} partidas no se pudieron casar; las demás sí quedaron.`);
  return lineas;
}

/** La causa del fallo, por codigo de la API (ProblemDetails) o del cliente. */
export function fraseDelFalloPiloto(error) {
  const code = String(error?.code || '');
  switch (code) {
    case 'PUERTA_CERRADA': return 'Esto solo existe en el negocio demo de Maderinco: aquí no se cargó nada.';
    case 'CONFIRMACION_REQUERIDA': return 'La API pidió confirmación y no se cargó nada; vuelve a intentarlo.';
    case 'NOT_IMPLEMENTED': return 'La carga del piloto todavía no está publicada en la API: no se cargó nada.';
    case 'SIN_SESION': return 'Tu sesión venció: entra de nuevo y vuelve a cargar.';
    case 'FORBIDDEN': return 'Tu usuario no tiene permiso para cargar el piloto.';
    case 'NETWORK': return 'Sin conexión con la API: no se cargó nada.';
    default: return `La API no pudo cargar el piloto (${code || 'sin código'}); no sabemos si alcanzó a crear algo: vuelve a cargarlo, repetirlo no duplica.`;
  }
}
